import { MapObjectColors } from '../../../map/core/map-object-colors';

/** Stable stage assignments into the architecture-owned category palette.
 * Shared by Leads board, badges, rail and detail views; no local color values.
 */
export const STAGE_COLORS: Record<string, string> = {
  Prospect: MapObjectColors.slate,
  Presentation: MapObjectColors.mulberry,
  Negotiation: MapObjectColors.heather,
  Contract: MapObjectColors.copper,
  Won: MapObjectColors.olive,
  Lost: MapObjectColors.rose,
};

/** Unmapped tenant stages use the shared palette's subdued blue. */
export const STAGE_FALLBACK_COLOR = MapObjectColors.deepSea;

export function stageColor(stage: string | null | undefined): string {
  return (stage && STAGE_COLORS[stage]) || STAGE_FALLBACK_COLOR;
}
